import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';
import { Button, Holder } from '@src/components/elements';
import config from '@src/config';
import { Features } from './Features';
import { BigButton, ButtonWrapper, Note, Content, Headline, Hero, Wrapper, FeaturesWrapper, ButtonText, BottomCTA, } from './Candidate.style';
const Candidate = () => {
    const theme = useTheme();
    return (React.createElement(Wrapper, null,
        React.createElement(Hero, null,
            React.createElement(Holder, null,
                React.createElement(Headline, null,
                    React.createElement("h1", null,
                        React.createElement(FormattedMessage, { id: "candidate.headline" })),
                    React.createElement("h2", null,
                        React.createElement(FormattedMessage, { id: "candidate.subheadline_1" }),
                        React.createElement("br", null),
                        React.createElement(FormattedMessage, { id: "candidate.subheadline_2" }))))),
        React.createElement(Content, null,
            React.createElement(FeaturesWrapper, { id: "features" },
                React.createElement(Holder, null,
                    React.createElement("h2", null,
                        React.createElement(FormattedMessage, { id: "companies.features.headilne" })),
                    React.createElement(Features, null),
                    React.createElement(BigButton, { style: {
                            background: theme.color.success,
                            borderColor: theme.color.success,
                            color: theme.color.white,
                        }, link: "/ponuky" },
                        React.createElement(ButtonText, null,
                            React.createElement(FormattedMessage, { id: "home.hero.cta_offers_short" }))))),
            React.createElement(BottomCTA, null,
                React.createElement(Holder, null,
                    React.createElement("h2", null,
                        React.createElement(FormattedMessage, { id: "candidate.results" })),
                    React.createElement("p", null,
                        React.createElement(FormattedMessage, { id: "companies.results.subheadilne", values: {
                                companies: React.createElement("strong", null,
                                    config.marketing.companies,
                                    "+"),
                                offers: React.createElement("strong", null,
                                    config.marketing.offers,
                                    "+"),
                                responses: React.createElement("strong", null,
                                    config.marketing.responses,
                                    "+"),
                            } })),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(Button, { style: {
                                background: theme.color.success,
                                borderColor: theme.color.success,
                                color: theme.color.white,
                            }, link: "/registracia-student" },
                            React.createElement(ButtonText, null,
                                React.createElement(FormattedMessage, { id: "candidate.free.create_account_free" }))),
                        React.createElement(Note, null,
                            React.createElement(FormattedMessage, { id: "candidate.free.no_hidden_fees" }))))))));
};
export { Candidate };
